// Dans src/components/organisms/DuringMatch/modals/ConductModal.tsx
import { PlayerAvatar } from '../../../atoms';
import { useTranslation } from '../../../../i18n/hooks/useTranslation';

// Clés de justification pour les traductions
const JUSTIFICATION_KEYS = [
  'obscenity', 'abuse', 'contact', 'dangerous', 'dissent',
  'influence', 'equipment', 'warmup', 'delay', 'distraction', 'coaching'
] as const;

interface ConductModalProps {
  isOpen: boolean;
  action: string | null;
  playerName: string;
  playerColor: string;
  playerAvatar?: string;
  onJustification: (justification: string) => void;
  onClose: () => void;
}

export function ConductModal({
  isOpen,
  action,
  playerName,
  playerColor,
  playerAvatar,
  onJustification,
  onClose
}: ConductModalProps) {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div role="dialog" aria-modal="true" className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white p-4 w-[90vw] h-[90vh] flex flex-col relative">
        {/* Close button (X) */}
        <button
          onClick={onClose}
          className="absolute top-2 right-2 w-10 h-10 flex items-center justify-center text-gray-500 hover:text-gray-700 text-2xl font-bold"
          aria-label="Close"
        >
          ×
        </button>

        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-center md:gap-3 mb-4 pr-10">
          <h3 className="text-lg font-semibold text-center md:text-xl md:mb-0 mb-2">
            {action?.replace('conduct_', 'Conduct ').replace('_', ' ').replace('point', 'stroke')}
          </h3>
          <div className="flex items-center justify-center gap-2 py-2 font-semibold md:px-4 text-gray-900">
            <PlayerAvatar avatarUrl={playerAvatar} color={playerColor} size={28} ringWidth={2} alt={playerName} />
            {playerName}
          </div>
        </div>

        {/* Liste des justifications - 1 colonne en portrait, 2 colonnes en landscape */}
        <div className="flex-1 grid grid-cols-1 landscape:grid-cols-2 gap-2 overflow-y-auto content-start">
          {JUSTIFICATION_KEYS.map((key) => {
            const justificationText = t(`conduct.justifications.${key}` as any);
            return (
              <button
                key={key}
                onClick={() => onJustification(justificationText)}
                className="bg-gray-100 hover:bg-gray-200 font-semibold text-base md:text-lg lg:text-xl py-4 px-4 text-center"
              >
                {justificationText}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}